import { App } from "@capacitor/app";
import { useEffect } from "react";

import { useAppRemount } from "../appV2/context/AppRemountContext";
import { CbhFeatureFlag, useCbhFlag } from "../appV2/FeatureFlags";
import { logEvent } from "../appV2/lib/analytics";
import { APP_V2_APP_EVENTS } from "../appV2/lib/analytics/events";

// force the entire React tree to unmount and remount
export function useForceAppResetOnResume() {
  const isRemountingOnResumeEnabled = useCbhFlag(
    CbhFeatureFlag.GROWTH_WORKER_APP_DEBUGGING_REMOUNT_APP,
    {
      defaultValue: false,
    }
  );

  const { triggerRemount } = useAppRemount();

  useEffect(() => {
    if (!isRemountingOnResumeEnabled) {
      return;
    }

    const resumeListener = App.addListener("resume", () => {
      logEvent(APP_V2_APP_EVENTS.FORCE_APP_RESET_ON_RESUME);
      triggerRemount();
    });

    return () => {
      void resumeListener?.then(async (listener) => {
        await listener?.remove();
      });
    };
  }, [isRemountingOnResumeEnabled, triggerRemount]);
}
